// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classnames from 'classnames';
import {get} from 'lodash';

// Components

// Styles
import './main-nav.scss';

class MainNav extends Component {
    getClass() {
        const {className} = this.props;

        return classnames(className, 'main-nav');
    }

    render() {
        return <nav className={this.getClass()} />;
    }
}

MainNav.propTypes = {
    className: PropTypes.string,
    routerParams: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        routerParams: get(state.servicesSearchData, 'routerParams', {}),
    };
}

export default connect(mapStateToProps, null)(MainNav);
